import { render, staticRenderFns } from "./EnpsProblemCategories.vue?vue&type=template&id=18b15676"
import script from "./EnpsProblemCategories.vue?vue&type=script&lang=js"
export * from "./EnpsProblemCategories.vue?vue&type=script&lang=js"
import style0 from "./EnpsProblemCategories.vue?vue&type=style&index=0&id=18b15676&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports